var React = require('react');

function IntegratedChart (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M30 4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V4Zm-2 0H4v24h24V4ZM9 19H7v7h2v-7Zm12 0h-2v7h2v-7Zm-4-6h-2v13h2V13Zm-4-5h-2v18h2V8Zm12 8h-2v10h2V16Z"}));
}

IntegratedChart.defaultProps = {"xmlSpace":"preserve","style":{"fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2"},"viewBox":"0 0 32 32"};

module.exports = IntegratedChart;

IntegratedChart.default = IntegratedChart;
